<template>

  <div id="update-customer-dialog" class="ui modal update-customer-modal">

    <div class="ui header">
      Definição do Cliente
    </div>

    <div class="content modal-content-scrolling">

      <form class="ui form" @submit.prevent="onConfirm()">        
        <div class="fields">
          <div class="four wide field">
            <label class="form-label">Código <span class="red text">*</span></label>
            <div class="ui action input">
              <input type="text" readonly="readonly" maxlength="6" v-model="customerCode">
              <!--
              <button type="button" class="ui basic icon button" @click="$refs.customerPicker.show()">
                <i class="search plus black icon"></i>
              </button>
              -->
            </div>
          </div>
          <div class="two wide field">
            <label class="form-label">Loja <span class="red text">*</span></label>
            <input type="text" readonly="readonly" maxlength="2" v-model="customerUnit">
          </div>
          <div class="ten wide field">
            <label class="form-label">Razão Social</label>
            <input type="text" readonly="readonly" :value="customer.name">
          </div>
        </div>
        <div class="fields">
          <div class="six wide field">
            <label class="form-label">CNPJ</label>
            <input type="text" readonly="readonly" :value="customer.formatCnpj">
          </div>
          <div class="five wide field">
            <label class="form-label">Inscrição Estadual</label>
            <input type="text" readonly="readonly" :value="customer.ie">
          </div>
          <div class="five wide field">
            <label class="form-label">Telefone</label>
            <input type="text" readonly="readonly" :value="customer.phone ? customer.ddd + ' ' + customer.phone : ''">
          </div>
        </div>
        <div class="fields">
          <div class="sixteen wide field">
            <label class="form-label">Endereço</label>
            <input type="text" readonly="readonly" :value="customerAddress">
          </div>
        </div>
      </form>

    </div>

    <div class="actions">
      <button class="ui cancel basic button">
        <i class="times icon"></i>
        Cancelar
      </button>
      <button type="button" class="ui blue button" :class="{ disabled: !customer.name }" @click="onConfirm()">
        <i class="check icon"></i>
        Confirmar
      </button>
    </div>

    <customer-picker ref="customerPicker" :allowMultiple="true" @onSelect="onSelectCustomer" />

  </div>    

</template>

<script>

  import CustomerPicker from "@/components/customer-picker.vue"
  import CustomerService from "@/services/customer-service"
  import Message from "@/utils/message"

  export default {

    data() {
      return {
        final: true,
        loading: false,
        customerCode: "",
        customerUnit: "",
        customer: {},
      }
    },
    props: ["quotation"],
    computed: {

      customerAddress() {
        return CustomerService.customerAddress(this.customer)
      },
    },    
    beforeDestroy() {
      $(".update-customer-modal").remove()
    },

    components: {
      CustomerPicker,
    },    

    methods: {

      show(quotation, final=true) {
        this.final = final
        this.quotation = quotation
        this.loadCustomer()
        $("#update-customer-dialog").modal("show")
      },

      hide() {
        $("#update-customer-dialog").modal("hide")
      },

      onBlurCustomerCode() {

        if (!this.customerCode) {
          this.customerUnit = ""
          this.customer = {}
          return
        }  

        if (!this.customerUnit)
          this.customerUnit = "01"

        this.loadCustomer()
      },

      onBlurCustomerUnit() {

        if (this.customerCode && this.customerUnit)
          this.loadCustomer()
      },

      async loadCustomer() {

        this.loading = true

        try {
          const customer = await CustomerService.getByCnpj(this.quotation.CnpjPadrao.trim())
          if (customer.isBlocked) {
            Message.info("Cliente bloqueado")
          } else if(customer.cnpj !== this.quotation.CnpjPadrao ) {
            Message.info("Utilizar cliente com mesmo CNPJ" + this.quotation.CnpjPadrao + ", do orçamento")
          } else {
            this.customerCode  = customer.code
            this.customerUnit  = customer.unit
            this.customer      = customer
          }

          this.loading = false          

        } catch (error) {

          this.loading = false
          this.customer = {}

          this.$errorHandler(error)
        }
      },

      onSelectCustomer(customer) {

        this.customerCode = customer.code
        this.customerUnit = customer.unit
        this.customer = customer
      },

      onConfirm() {

        if (CustomerService.isDefaultCustomer(this.customer)) {
          Message.info("Defina um cliente diferente do cliente padrão")
          return
        }

        this.$emit("onSelectCustomer", this.$cloneObject(this.customer), this.final)

        this.hide()

        this.customerCode = ""
        this.customerUnit = ""
        this.customer = {}
      },
    },
  }

</script>

